<div *ngIf="isLoggedIn()">
  <app-books></app-books>
</div>